<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>我的圈子</span>
        <button v-if="listData.length > 0" class = "title_top_right_btn personal_add_btn rt" @click = "boardLayer('add')">创建圈子</button>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="my_circle"
    :class="listData.length === 0 ? 'my_none' : ''"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <circle-view
      v-if="listData.length > 0"
      :list="listData"
      :type="type"
      :limit="listLimit"
      @edit="editBoard">
      </circle-view>
      <div v-if="listData.length === 0 && !listLoading" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/myCircleListNone.png" alt="创建圈子列表为空"><br/>
        您还没有创建属于自己的圈子，快来<a class="my_none_btn" @click="boardLayer('add')">创建</a>吧！
      </div>
    </div>
    <!-- 创建圈子弹窗 -->
    <el-dialog title="创建圈子"
    :visible.sync = "addBoardOnOff"
    :close-on-click-modal = 'false'
    :show-close = 'false'
    :close-on-press-escape = 'false'
    >
      <el-form :model="addBoardForm" :rules="rules" ref="addBoardForm" :hide-required-asterisk='true'>
        <el-form-item label="圈子名称" prop="board_name">
          <el-input v-show="!editOnOff || addBoardForm.is_delete === 0" v-model="addBoardForm.board_name" autocomplete="off"></el-input>
          <el-input v-show="editOnOff && addBoardForm.is_delete !== 0" v-model="addBoardForm.board_name" :disabled="true" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="圈子简介" prop="content">
          <el-input  type="textarea" rows="3" v-model="addBoardForm.content" show-word-limit maxlength="50" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="圈子头像">
          <img-upload-view :filestype="addBoardForm.filesType" :imgurl="addBoardForm.pic" @files="imgFile"></img-upload-view>
        </el-form-item>
      </el-form>
      <div v-if="!dialogBtnOnOff" slot="footer" class="dialog-footer">
        <el-button @click="addBoardOnOff = false">取 消</el-button>
        <el-button v-show="!editOnOff" type="primary" @click="createBoard('addBoardForm')">确 定</el-button>
        <el-button v-show="editOnOff" type="primary" @click="editBoardSub('addBoardForm')">确 定</el-button>
      </div>
      <div v-if="dialogBtnOnOff" slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="true">提交中</el-button>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <el-pagination
      v-if="listData.length > 0"
      background
      layout="prev, pager, next"
      :page-size= "listLimit"
      :total="listNum"
      @current-change = "pageChange">
    </el-pagination>
  </div>
</template>

<script>
import circle from '../Public/circle.vue'
import imgupload from '../Public/imgUpload.vue'
export default {
  components: {
    circleView: circle,
    imgUploadView: imgupload
  },
  data () {
    return {
      listData: [], // 文章列表
      listNum: 0, // 文章总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true, // 开启加载动画
      type: 'personalMy',
      addBoardOnOff: false, // 创建圈子弹窗开关
      editOnOff: false, // 修改圈子开关
      editBoardInfo: { // 修改圈子相关信息
        id: '',
        index: ''
      },
      addBoardForm: { // 创建圈子表单提交内容
        board_name: '',
        content: '',
        pic: '',
        filesType: 'circleImg'
      },
      rules: { // 创建圈子验证规则
        board_name: [
          { required: true, message: '请输入圈子名称', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入圈子简介', trigger: 'blur' }
        ]
      },
      dialogBtnOnOff: false, // 圈子弹窗按钮提交加载不可点击，防止重复点击
      user: null // 圈子列表用户信息
    }
  },
  created () {
    this.pageChange()
  },
  methods: {
    // 获取数据
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.boardIndex(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.data
          vueThat.listNum = res.data.data.count
        }
      })
    },
    // 获取图片上传组件传递的图片地址
    imgFile (url) {
      this.addBoardForm.pic = url
    },
    // 圈子弹窗弹出
    boardLayer (type) {
      const vueThat = this
      vueThat.addBoardOnOff = true
      if (type === 'add') {
        vueThat.addBoardTitle = '创建圈子'
        vueThat.addBoardForm.board_name = ''
        vueThat.addBoardForm.content = ''
        vueThat.addBoardForm.pic = ''
      } else {
        vueThat.addBoardTitle = '修改圈子信息'
      }
    },
    // 创建圈子弹窗
    createBoard (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          vueThat.dialogBtnOnOff = true
          if (vueThat.addBoardForm.pic === '') {
            vueThat.$message({
              message: '请上传圈子头像',
              type: 'error'
            })
            vueThat.dialogBtnOnOff = false
          } else {
            vueThat.myApi.createBoard(vueThat.addBoardForm).then((res) => {
              if (res.data.code === 200) {
                this.$alert('圈子创建成功', '温馨提示', {
                  confirmButtonText: '确定',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  type: 'success',
                  callback: action => {
                    vueThat.addBoardOnOff = false
                    vueThat.$refs[formName].resetFields()
                    vueThat.addBoardForm.pic = ' '
                    vueThat.dialogBtnOnOff = false
                    // 获取我的圈子列表
                    vueThat.pageChange()
                  }
                })
              } else {
                vueThat.dialogBtnOnOff = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 修改圈子信息提交接口
    editBoardSub (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          vueThat.dialogBtnOnOff = true
          if (vueThat.addBoardForm.pic === '') {
            vueThat.$message({
              message: '请上传圈子头像',
              type: 'error'
            })
            vueThat.dialogBtnOnOff = false
          } else {
            const obj = vueThat.addBoardForm
            obj.board_id = vueThat.editBoardInfo.id
            obj.synopsis = vueThat.addBoardForm.content
            vueThat.myApi.eoardEditSub(vueThat.addBoardForm).then((res) => {
              if (res.data.code === 200) {
                this.$alert('圈子信息修改成功', '温馨提示', {
                  confirmButtonText: '确定',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  type: 'success',
                  callback: action => {
                    const obj1 = Object.assign(vueThat.listData[vueThat.editBoardInfo.index], vueThat.addBoardForm)
                    vueThat.listData.splice(vueThat.editBoardInfo.index, 1, obj1)
                    vueThat.addBoardOnOff = false
                    vueThat.editOnOff = false
                    vueThat.editBoarId = ''
                    vueThat.$refs[formName].resetFields()
                    vueThat.addBoardForm.pic = ' '
                    vueThat.dialogBtnOnOff = false
                  }
                })
              } else {
                vueThat.dialogBtnOnOff = false
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 修改圈子弹窗弹出信息
    editBoard (data, index) {
      console.log(data)
      const vueThat = this
      vueThat.editBoardInfo.id = data.board_id
      vueThat.editBoardInfo.index = index
      vueThat.editOnOff = true
      vueThat.addBoardOnOff = true
      vueThat.addBoardForm.board_name = data.board_name
      vueThat.addBoardForm.content = data.synopsis
      vueThat.addBoardForm.pic = data.pic
      vueThat.addBoardForm.is_delete = data.is_delete
    }
  }
}
</script>

<style>
</style>
